import { api } from "../../api";
import {handleResponse, RequestOptions} from "../types";
import {getCookie} from "../../helpers/utils";
import {cookieToken} from "../../constants";

const updatePasswordData = (data: any) => {
  const payload = {
    ...data.data,
  }

  const locale = data.locale === 'ru' ? 'ru_RU' : 'en_US';

  return fetch(`${api.agent.profile.update_password}?locale=${locale}`, {...RequestOptions('PUT', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
}

export const agentProfileService = {
  updatePasswordData,
};
